export default "__VITE_PUBLIC_ASSET__461af90f__"